
import {Component, Vue} from 'vue-property-decorator';
import AppPageHeader from "@/components/AppPageHeader.vue";
import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import FindDriverIntro from "@/modules/FindDriver/components/FindDriverIntro.vue";

@Component({
  components: {
    FindDriverIntro,
    AppPageHeader,
  },
})
export default class PageFindDriver extends Vue {
  $refs: any;
  isLoading: boolean = true;

  get storeState(): IAppState { return this.$store.state; }
  get popups(): IDialogStoreState { return this.storeState.dialog; }

  async created() {
    try {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }
    catch (error) { await this.$store.dispatch('handleError', error) }
  }
}
